'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _toHsla=require('./../conversionFunctions/toHsla');var _toHsla2=_interopRequireDefault(_toHsla);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}exports.default=function(color){return(0,_toHsla2.default)(color).luminance};


//////////////////
// WEBPACK FOOTER
// ../~/@andrew-codes/color-functions/dist/functions/getLuminance.js
// module id = 564
// module chunks = 0